// Stamped by scripts/write-release.mjs when GITHUB_SHA or .preview-client-id is
// present. These committed values are the local and unit-test defaults.
// releaseVersion matches the Datadog sourcemap upload (`github.sha`).
// previewClientId is the ephemeral Sirius client for a PR preview.
export const releaseVersion = '46d7ad54edc23f7f03dbee99573730ea3b658b3b';
export const previewClientId = 'future-room-preview-future-room-4-s5fzvqmb';
